module.exports = __webpack_public_path__ + "img/louisa-may-alcott.4aa66cc9.png";